import axiosService from './axios-service';
import { ChatAnswerResponse, ChatHistoryDetails } from '@src/model/chat-bot';

class ChatBotService {

    public postQuestion = async (customerId: number, serviceId: number, question: string): Promise<ChatAnswerResponse> => {
        const path = `/api/orchestrator/customer/${customerId}/service/${serviceId}/chat-history/post-question`;
        const res = await axiosService.post(path, {
            inputRequest: question
        });
        return res?.data;
    };

    public getChatHistory = async (customerId: number, serviceId: number, count = 10): Promise<ChatHistoryDetails[]> => {
        const path = `/api/orchestrator/customer/${customerId}/service/${serviceId}/chat-history/get-chat-details?count=${count}`;
        const res = await axiosService.get(path);
        return res?.data;
    };
}

const chatBotService = new ChatBotService();
export default chatBotService;